import React from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../../Context';
import Flex from '../../../../Flex';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import FluidMargin from '../FluidMargin';
import { useDeviationAttributes } from '../../../_partials/hooks/useDeviationAttributes';
import { getDeviationType } from '../../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButton';
import AddToGroupButton from '../../../buttons/AddToGroupButton';
import ShareButton from '../../../buttons/ShareButton';
import MoreButton from '../../../buttons/MoreButton';
import { useFlag } from '../../../../redux/flags/hooks';
import s from '../DesktopActionBar.scss';
export var SecondaryDesktopActionBar = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var isTheater = useDeviationViewContext().isTheater;
    var _b = useDeviationAttributes(deviation, isOwner), isCommentable = _b.isCommentable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, isShareable = _b.isShareable, hasMoreActions = _b.hasMoreActions;
    var isTextual = [
        DeviationTypes.LITERATURE,
        DeviationTypes.PROJECT,
    ].includes(getDeviationType(deviation));
    var hasCoreBadges = useFlag('core_badges');
    return (React.createElement(ActionBarStrip, { className: classnames(s['root'], isTheater ? s['theater'] : s['normal-view'], isOwner && s['owner'], isTextual && s['literature'], s['secondary']) },
        React.createElement("div", { className: s['icons-wrapper'] },
            React.createElement("div", { className: s['badge'] }),
            React.createElement(FluidMargin, { index: 1 }),
            React.createElement("div", { className: s['icons-middle'] },
                React.createElement(Flex, { alignItems: "center" },
                    isFavouritable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(FavouriteButton, { deviation: deviation, actionBarType: "secondary" }))),
                    isCommentable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner, actionBarType: "secondary" })))),
                React.createElement(FluidMargin, { index: 4 }),
                React.createElement(Flex, { alignItems: "center" },
                    isGroupSubmittable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(AddToGroupButton, { deviation: deviation, actionBarType: "secondary" }))),
                    !hasCoreBadges && isShareable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(ShareButton, { deviation: deviation }))),
                    hasMoreActions && (React.createElement("span", { className: s['icon'] },
                        React.createElement(MoreButton, { deviation: deviation })))),
                React.createElement(FluidMargin, { index: 2 }),
                React.createElement(Flex, { alignItems: "center" })),
            React.createElement(FluidMargin, { index: 3 }),
            React.createElement("div", { className: s['icons-right'] }))));
};
SecondaryDesktopActionBar.displayName = 'SecondaryDesktopActionBar';
export default SecondaryDesktopActionBar;
//# sourceMappingURL=SecondaryDesktopActionBar.js.map